// src/reviewer/index.js
// http://localhost:3000/?utm_source=yc_review
// http://localhost:3000/?utm_source=grant_review


const reviewerConfigs = {
  yc_review: {
    nome: "YC",
    badge: "YC Reviewer",
    badgeIcon: "fab fa-y-combinator",
    badgeText: "HELLO",
    overlay: "Tailored demo for YC reviewers.",
    loginHint: true,
    defaultEmail: "reviewer@yc.com",
    defaultPassword: "demo1234",
  },
  grant_review: {
    nome: "grant",
    badge: "Grant Reviewer",
    overlay: "Welcome grant reviewers.",
    loginHint: false,
    defaultEmail: "guest@lithopsbio.com",
    defaultPassword: "demo1234",
  },
  default: {
    nome: null,
    badge: null,
    overlay: null,
    loginHint: false,
    defaultEmail: null,
    defaultPassword: null,
  },
};


export function getReviewerConfig() {
  const params = new URLSearchParams(window.location.search);
  const utm = params.get("utm_source");

  if (utm) {
    window.history.replaceState({}, document.title, window.location.pathname); // strips the query string
    //localStorage.setItem("reviewer_source", utm); //  optional: persists across reloads
    sessionStorage.setItem("reviewer_source", utm); // ✅ persists only for session
  }

  //const source = utm || localStorage.getItem("reviewer_source");
  const source = utm || sessionStorage.getItem("reviewer_source");
  console.log("window.location.search:", window.location.search);
  console.log("utm_source param:", utm);
  console.log("sessionStorage reviewer_source:", sessionStorage.getItem("reviewer_source"));

  return reviewerConfigs[source] || reviewerConfigs.default;
}